import { MenuItem } from '@components';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { IMenuItem } from '../../../store/reducers/menu';

const MenuSidebar = () => {
    const user = useSelector((state: any) => state.auth.currentUser);
    const sidebarSkin = useSelector((state: any) => state.ui.sidebarSkin);
    const menuItemFlat = useSelector((state: any) => state.ui.menuItemFlat);
    const menuChildIndent = useSelector((state: any) => state.ui.menuChildIndent);
    const isAvailableMenu = useSelector((state: any) => state.menu.isAvailableMenu);
    const menu = isAvailableMenu ? JSON.parse(localStorage.getItem('menu') || '{}') : useSelector((state: any) => state.menu.items);

    return (
        <aside className={`main-sidebar elevation-4 ${sidebarSkin}`} style={{ bottom: 0 }}>
            <Link to="/" className="brand-link">
                <img
                    src="/img/ddif_logo.png"
                    alt="Hệ thống quản lý nhân sự Quỹ Đầu tư phát triển thành phố Đà Nẵng"
                    width={30}
                    height={30}
                    style={{ borderRadius: '10%', marginRight: "10px" }}
                />
                <span className="brand-text">DDIF HRM</span>
            </Link>
            <div className="sidebar">
                <nav className="mt-2" style={{ overflow: 'hidden' }}>
                    <ul
                        className={`nav nav-pills nav-sidebar flex-column${menuItemFlat ? ' nav-flat' : ''}${menuChildIndent ? ' nav-child-indent' : ''}`} role="menu">                   {
                            (menu || []).filter((menuItem: IMenuItem) => menuItem.url || (menuItem.children || []).filter(x => x.hienThi).length > 0).map((menuItem: IMenuItem) => (
                                <MenuItem
                                    key={menuItem.tenChucNang + menuItem.url}
                                    menuItem={menuItem}
                                />
                            ))
                        }
                    </ul>
                </nav>
            </div>
        </aside>
    );
};

export default MenuSidebar;
